import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/signin',
    redirect: '/',
  },
  {
    path: '/signout',
    redirect: '/',
  },
  {
    path: '/',
    component: () => import('@/views/WellgroupList.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
